
import { useStore } from "@/stores/order";
import dayjs from "dayjs";
import { defineComponent, computed, watch, ref, reactive } from "vue";
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition";
import { mdiCheckCircle } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";

export default defineComponent({
  setup() {
    const store = useStore();

    const order = computed(() => store.order);
    const invoice = computed(() => order.value?.invoice);

    const date_paid = computed(() => {
      return dayjs(invoice.value?.paid ?? order.value?.paid).format("L LT");
    });

    const date_invoiced = computed(() => {
      return dayjs(invoice.value?.date).format("L LT");
    });

    const messageClass = computed(() => {
      return {
        success: store.isPayed,
        info: !store.isPayed,
      }
    });

    return {
      order,
      date_paid,
      invoice,
      date_invoiced,
      messageClass,
      checkIcon: mdiCheckCircle,
      isPayed: computed(() => store.isPayed),
    };
  },
  components: { CollapseTransition, SvgIcon }
});
